import {Component, OnInit, signal, ViewChild, WritableSignal} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {NgIf} from "@angular/common";
import {
  LoadingPanelService, SafeResourcePipe,
  SvgLoaderComponent, VisorComponent,Utils
} from 'lib-base';
import {SkeletonModule} from "primeng/skeleton";
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin, lastValueFrom} from "rxjs";
import {Router} from "@angular/router";
import {FacturaService} from "../../../../services/liquidacion/factura.service";
import {TramiteFirmasElectronicasService} from "../../../../services/tramiteFirmasElectronicas.service";
import {RequestGenerarFirmadoDigital} from "../../../../shared/interfaces/firma_electronica";
import {TramRegistroSolicitudService} from "../../../../services/tramiteRegistroSolicitud.service";

@Component({
  selector: 'app-detalle-radicado',
  standalone: true,
  imports: [
    ButtonDirective,
    NgIf,
    SafeResourcePipe,
    SkeletonModule,
    SvgLoaderComponent,
    VisorComponent
  ],
  templateUrl: './detalle-radicado.component.html',
  styleUrl: './detalle-radicado.component.scss'
})
export class DetalleRadicadoComponent implements OnInit {
  translations!: any;
  nombreTramite: WritableSignal<string | null> = signal(null);
  url: WritableSignal<string | null> = signal(null);
  #idTramite!: number;

  @ViewChild(VisorComponent, {static: true}) visorComponent!: VisorComponent;

  constructor(private _t: TranslateService, private _f: FacturaService, private _trsolService: TramRegistroSolicitudService,
              private _lps: LoadingPanelService, private _tfes: TramiteFirmasElectronicasService,
              private _router: Router) {
    this.getDataRouting();
  }

  ngOnInit(): void {
    this.initTranslations();
    this.getDescripcion();
    this.getTramiteRadicado();
  }

  async initTranslations() {
    this.translations =
      await firstValueFrom(forkJoin({
        header: this._t.get('components.app-detalle-radicado.header'),
        subHeader: this._t.get('components.app-detalle-radicado.sub-header'),
        descargar: this._t.get('common.descargar'),
        tramiteInactivo: this._t.get('common.descargar'),
        volver: this._t.get('form.button.finalizar'),
      }));

  }

  getTramiteRadicado() {
    this._lps.show(true)
    const body: RequestGenerarFirmadoDigital = {
      tramRegistroSolicitud: this.#idTramite
    }
    this._tfes.generarTramiteFirmado(body).subscribe({
      next: value => {
        this._lps.hide();
        this.sendEmailRadicado().then();
        if (value.size) {
          this.url.set(URL.createObjectURL(value));
        }
      },error: err => {
        this._lps.hide()
      }
    });
  }

  private async sendEmailRadicado() {
    return await lastValueFrom(this._tfes.enviarTramiteFirmado(this.#idTramite))
  }

  private getDataRouting = () => {
    const navigation = this._router.getCurrentNavigation();
    this.#idTramite = navigation?.extras.state?.['data'];
  };

  getDescripcion() {
    this._lps.show(true)
    this._trsolService.getDescripcion(this.#idTramite).subscribe({
      next: value => {
        this._lps.hide();
        this.nombreTramite.set(
          `${value.descripcion} ${value.subTramite ? ' - '+ value.subTramite :''}`
        );
      }, error: err=>{
        this._lps.hide();
      }
    })
  }

  get isMobile(){
    return Utils.isMobile();
  }

  redirectToHome(){
    this._router.navigate(['/tramites', 'estado-tramite'])
  }
}
